module.exports = __webpack_public_path__ + "img/sos.d8797c16.svg";